"use client";
import React from "react";
import {
    CalendarSelect,
    CalendarSelectProps,
} from "../../calendars/calendar-select";
import {
    FormFieldController,
    FormFieldControllerProps,
} from "../form-field-controller";

export type FormCalendarSelectProps =
    FormFieldControllerProps<CalendarSelectProps>;
export const FormCalendarSelect: React.FC<FormCalendarSelectProps> = ({
    validation,
    name,
    ...inputProps
}) => {
    return (
        <FormFieldController name={name} validation={validation}>
            <CalendarSelect fieldId={name} {...inputProps} />
        </FormFieldController>
    );
};
